// extracted by mini-css-extract-plugin
export default {"wrapper":"R0-z","play":"S0-z"};